// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2AB7S","largestCol":"styles_largestCol__1aEbI","smallestCol":"styles_smallestCol__957oI"};